import React from 'react';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, Media} from 'reactstrap';
import { Translate } from "react-localize-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faUser, faIdCard, faDownload, faCogs, faIdBadge, faChartPie, faPrint, faDesktop, faSignInAlt, faSignOutAlt} from '@fortawesome/free-solid-svg-icons';
import { NavLink } from "react-router-dom";
import SessionManager from "../../custom-classes/session-manager";

export default class NavbarMobile extends React.Component {
    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true,
            isLoggedIn: SessionManager.getSession() != null && SessionManager.getSession().length > 0
        };
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    render() {
        return (
            <div>
                <Navbar className="navbar-mobile navbar-landing" color="faded" dark>
                    <NavbarBrand href="/" className="mr-auto">
                        <Media src={require('../../img/logo-gs-a.png')} alt="Company logo"
                               className="logo-mob"/>
                    </NavbarBrand>
                    <NavbarToggler onClick={this.toggleNavbar} className="mr-2 navbar-button" />
                    <Collapse isOpen={!this.state.collapsed} navbar>
                        <Nav navbar>
                            <NavItem>
                                <NavLink to="/" className="navbar-button">
                                    <FontAwesomeIcon icon={faHome} />{' '}
                                    <Translate id="navbar.home" options={{renderInnerHtml: false}}/>
                                </NavLink>
                            </NavItem>
                            {this.state.isLoggedIn ?
                                <NavItem>
                                    <NavLink to="/dashboard" className="navbar-button">
                                        <FontAwesomeIcon icon={faDesktop} />{' '}
                                        <Translate id="navbar.dashboard" options={{renderInnerHtml: false}}/>
                                    </NavLink>
                                </NavItem> : null
                            }
                            {!this.state.isLoggedIn ?
                                <NavItem>
                                    <NavLink to="/login" className="navbar-button">
                                        <FontAwesomeIcon icon={faSignInAlt}/>{' '}
                                        <Translate id="navbar.login" options={{renderInnerHtml: false}}/>
                                    </NavLink>
                                </NavItem> : null
                            }
                                <NavItem>
                                    <NavLink to="/select-plan" className="navbar-button">
                                        <FontAwesomeIcon icon={faIdCard}/>{' '}
                                        {!this.state.isLoggedIn ?
                                            <Translate id="navbar.subscribe" options={{renderInnerHtml: false}}/>
                                            :
                                            <Translate id="navbar.add-new-plan" options={{renderInnerHtml: true}}/>
                                        }
                                    </NavLink>
                                </NavItem>
                            {this.state.isLoggedIn ?
                                <NavItem>
                                    <NavLink to="/report-results" className="navbar-button">
                                        <FontAwesomeIcon icon={faPrint} />{' '}
                                        <Translate id="navbar.print-results" options={{renderInnerHtml: false}}/>
                                    </NavLink>
                                </NavItem> : null
                            }
                            {this.state.isLoggedIn ?
                                <NavItem>
                                    <NavLink to="/report-average" className="navbar-button">
                                        <FontAwesomeIcon icon={faChartPie} />{' '}
                                        <Translate id="navbar.student-average" options={{renderInnerHtml: false}}/>
                                    </NavLink>
                                </NavItem> : null
                            }
                            {this.state.isLoggedIn ?
                                <NavItem>
                                    <NavLink to="/profile-update" className="navbar-button">
                                        <FontAwesomeIcon icon={faUser} />{' '}
                                        <Translate id="navbar.update-students" options={{renderInnerHtml: true}}/>
                                    </NavLink>
                                </NavItem> : null
                            }
                            {this.state.isLoggedIn ?
                                <NavItem>
                                    <NavLink to="/update-information" className="navbar-button">
                                        <FontAwesomeIcon icon={faCogs} />{' '}
                                        <Translate id="navbar.settings" options={{renderInnerHtml: false}}/>
                                    </NavLink>
                                </NavItem> : null
                            }

                            <NavItem>
                                <NavLink to="/download" className="navbar-button">
                                    <FontAwesomeIcon icon={faDownload} />{' '}
                                    <Translate id="navbar.download" options={{renderInnerHtml: false}}/>
                                </NavLink>
                            </NavItem>
                            {this.state.isLoggedIn ?
                                <NavItem>
                                    <NavLink to="/login" className="navbar-button">
                                        <FontAwesomeIcon icon={faSignOutAlt} />{' '}
                                        <Translate id="navbar.logout" options={{renderInnerHtml: false}}/>
                                    </NavLink>
                                </NavItem> : null
                            }
                        </Nav>
                    </Collapse>
                </Navbar>
            </div>

        );
    }
}